import { SidebarInset, SidebarProvider } from "@repo/shad/ui/sidebar"
import { WallpaperColorSwitch } from "@repo/ui/components/wallpaper"
import { Outlet, useLocation } from "@tanstack/react-router"
import { useLayoutEffect, useRef, type CSSProperties } from "react"

import type { ShellLayoutProps } from "../types"

export function ShellLayout({
  sidebar,
  header,
  children,
  wallpaper = true,
  sidebarWidth = "calc(var(--spacing) * 72)",
  headerHeight = "calc(var(--spacing) * 12)",
}: ShellLayoutProps) {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const pathname = useLocation({ select: (location) => location.pathname })

  useLayoutEffect(() => {
    scrollContainerRef.current?.scrollTo({ top: 0, left: 0 })
    window.scrollTo({ top: 0, left: 0 })
  }, [pathname])

  return (
    <div className="relative h-svh">
      {wallpaper && (
        <WallpaperColorSwitch aria-hidden className="pointer-events-none fixed inset-0 z-0" />
      )}
      <SidebarProvider
        className="relative z-10 !min-h-0 h-full"
        style={
          {
            "--sidebar-width": sidebarWidth,
            "--sidebar": "transparent",
            "--header-height": headerHeight,
          } as CSSProperties
        }
      >
        {sidebar}
        <SidebarInset className="min-h-0">
          {header}
          <div
            ref={scrollContainerRef}
            className="flex flex-1 flex-col overflow-y-auto [scrollbar-gutter:stable]"
          >
            <div className="@container/main flex flex-1 flex-col gap-2">
              <div className="flex flex-col gap-4 py-2 md:gap-6 md:py-0">
                {children ?? <Outlet />}
              </div>
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </div>
  )
}
